<form [formGroup]="insertionCycleForm">
  <div class="form-group row">
    <div class="col s12 insertion-cycles">
      <app-picklist
        *ngIf="line"
        [formControl]="insertionCycleForm.controls['insertionCycles']"
        [showValidations]="showValidations"
        [source]="allInsertionCycles"
        formControlName="insertionCycles"
        sourceHeader="{{'admin.lines.create-modal.insertion-cycles.pick-list.leftHeader' | translate}}"
        targetHeader="{{'admin.lines.create-modal.insertion-cycles.pick-list.rightHeader' | translate}}"
        infoLabel="{{'admin.lines.create-modal.insertion-cycles.alert.message' | translate}}">
      </app-picklist>
    </div>
  </div>
</form>
